import React from 'react';

export const LinkDownloadSpinner = ({ height = 24, width = 24, label = 'Descargando ...' }) => {
  return (
    <div className="d-flex justify-content-start">
      <div className="spinner-border text-warning mr-2" role="status" aria-hidden="true" style={{ height: height, width: width }}></div>
      <span className="mt-1">{label}</span>
    </div>
  );
};

export default LinkDownloadSpinner;
